import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { formatCurrency } from 'js/services/Format';
import OrderDashboardStore from 'js/stores/pages/AdminDashboardPage/OrderDashboardStore';
import LoadingSpinner from '../../LoadingSpinner';

import DashPanel from '../../DashPanel';
import Header from '../../DashPanel/Header';
import Content from '../../DashPanel/Content';
import Pagination from '../../DashPanel/Pagination';
import Search from '../../DashPanel/Search';
import DropMenu from '../../DashPanel/DropMenu';
import Title from '../../DashPanel/Title';
import Controls from '../../DashPanel/Controls';

import Link from './Link';
import GotoItem from './GotoItem';
import Date from './Date';
import { default as LinkTitle } from './Title';
import Price from './Price';
import Image from './Image';
import Status from './Status';
import NotFound from './NotFound';

@observer
export default class Dashboard extends Component {
  orderList = OrderDashboardStore.create({ page: parseInt(this.props['*']) || 1 });

  constructor(props) {
    super(props);
    this.orderList.load();
  }

  componentDidUpdate() {
    this.orderList.setPage(this.props['*']);

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('f') && urlParams.has('q')) {
      this.orderList.setQueryParams({
        field: urlParams.get('f'),
        query: urlParams.get('q'),
      });
    }
  }

  render() {
    return (
      <DashPanel>
        <Header>
          <DropMenu />
          <Title>Orders / Offers</Title>
          <Controls>
            <Search model={this.orderList} options={{ uid: 'Order ID' }} />
            <Pagination model={this.orderList} />
          </Controls>
        </Header>

        <Content>
          {this.orderList.isLoading ? (
            <LoadingSpinner />
          ) : this.orderList.orders.length ? (
            <div>
              {this.orderList.orders.map(order => (
                <Link to={`order/${order.uid}`} key={order.uid}>
                  <Image src={order.image} />
                  <Date>{order.updated_at}</Date>
                  <LinkTitle>
                    {order.title} (<Price>{formatCurrency(order.price)}</Price>
                    {order.location ? `, ${order.location}` : ''})
                  </LinkTitle>
                  <Status order={order} />
                  <GotoItem />
                </Link>
              ))}
            </div>
          ) : (
            <NotFound>No orders found</NotFound>
          )}
        </Content>
      </DashPanel>
    );
  }
}
